export const useI18n = () => {
  return useNuxtApp().$i18n.global;
};
